// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login_wrapper__3n7lB","form":"login_form__17j0r"};